import { useMemo } from "react"
import { useParams } from "react-router-dom"
import { NicheCards, NicheCardsSkeleton, useNiches } from "@/entities/taxonomy"
import { TaxonomyPostsPage } from "@/widgets/taxonomy-posts"

export function NichePage() {
	const { id } = useParams<{ id: string }>()
	const { data: niches = [], isLoading: nichesLoading } = useNiches()

	const niche = useMemo(() => {
		if (!id || !niches.length) return null
		return niches.find((n) => n.id === id)
	}, [id, niches])

	return (
		<TaxonomyPostsPage
			entityId={id}
			entity={niche}
			taxonomyLoading={nichesLoading}
			filterKey="nicheId"
			notFoundMessage="Ниша не найдена"
			kindLabel="Ниша"
			railTitle="Ниши"
			emptyMessage="Нет постов в этой нише"
			rail={
				nichesLoading ? (
					<NicheCardsSkeleton />
				) : (
					<NicheCards niches={niches} selectedNicheId={niche?.id} />
				)
			}
		/>
	)
}
